import { REACTIVATE_SUBSCRIPTION_INIT } from './types'

export const reactivateSubscriptionInit = payload => ({
  type: REACTIVATE_SUBSCRIPTION_INIT,
  payload
})
